'use strict';

angular.module('licensure.services')
    .factory('LicenseCategoryCertificationStatuses', ['$http', '$q', function ($http, $q) {
        return {
            get: function (args) {
                var d = $q.defer();

                $http
                    .get(apiLocation + '/api/licensecategorycertificationstatuses', {
                        params: args
                    })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        console.log(response.data);
                        // handle error
                    });

                return d.promise;
            },

            getVehicleCategoryStatuses: function (args) {
                var d = $q.defer();
                args.license_id = null;
                args.license_category_id = null;
                args.vehicle = true;
                $http
                    .get(apiLocation + '/api/licensecategorycertificationstatuses', {
                        params: args
                    })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        console.log(response.data);
                        // handle error
                    });

                return d.promise;
            },

            getByID: function (id) {
                var d = $q.defer();

                $http
                    .get(apiLocation + '/api/licensecategorycertificationstatuses/' + id, {
                        params: {}
                    })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        console.log(response.data);
                        // handle error
                    });

                return d.promise;
            },

            save: function (license_category_certification_status, license_id) {
                var d = $q.defer();

                var method = 'POST';
                var url = apiLocation + '/api/licensecategorycertificationstatuses/';
                if (!isUndefined(license_category_certification_status.id)) {
                    method = 'PUT'
                    url += license_category_certification_status.id
                }

                $http({
                    method: method,
                    url: url,
                    data: {
                        license_category_certification_status: license_category_certification_status,
                        license_id: license_id
                    }
                })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        // handle error
                    });

                return d.promise;
            }
        }
    }])
;